module.exports = __webpack_public_path__ + "static/media/BT_pro_male.da33552c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageViewer/BT_pro_male.jpg
// module id = 558
// module chunks = 0